// Officials-only shooter mark categories. Must match ALLOWED_CATEGORIES in
// backend/app/routes/api/shootermarks/post-shootermark.js.
export const SHOOTER_MARK_CATEGORIES = [
    {
        name: 'virrete',
        label: 'Virrete',
        icon: 'fa-duotone fa-arrows-spin',
        textClass: 'text-warning',
        btnClass: 'btn-warning',
    },
    {
        name: 'farlig',
        label: 'Farlig',
        icon: 'fa-duotone fa-triangle-exclamation',
        textClass: 'text-danger',
        btnClass: 'btn-danger',
    },
    {
        name: 'vanskelig',
        label: 'Vanskelig',
        icon: 'fa-duotone fa-user-xmark',
        textClass: 'text-info',
        btnClass: 'btn-info',
    },
];

export function shooterMarkTitle(mark) {
    if (!mark) {
        return '';
    }
    const labels = SHOOTER_MARK_CATEGORIES
        .filter(cat => (mark.categories || []).includes(cat.name))
        .map(cat => cat.label);
    const parts = [labels.join(', ')];
    if (mark.note) {
        parts.push(mark.note);
    }
    return parts.filter(part => part).join(' - ');
}
